import { SxStyles } from '../../../../../../types';
import theme from '../../../../../../theme';
import { getResponsiveSize } from '../../../../../../utils';

export const PsylarisVideoItemStyle: SxStyles = {
  psylarisVideoItem: {
    position: 'relative',
    padding: getResponsiveSize(3),
    borderRadius: getResponsiveSize(5),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'all .3s ease-in-out',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.myPrimary?.lightBlue50,
    },
    '& .category-item_player_container': {
      '& .category-item_player': {},
    },
    '&.selected': {
      backgroundColor: theme.palette.myPrimary?.lightBlue70,
    },

    '& .category-item_image_container': {
      position: 'relative',

      '& .category-item_image': {
        width: getResponsiveSize(150),
        height: getResponsiveSize(90),
        borderRadius: getResponsiveSize(5),
        objectFit: 'cover',
      },
    },
    '& .description-container': {
      display: 'flex',
      justifyContent: 'center',
      position: 'absolute',
      bottom: '15%',
      width: getResponsiveSize(140),

      '& .description': {
        textTransform: 'capitalize',
        fontFamily: theme.typography.mainFontFamily,
        fontSize: getResponsiveSize(12),
        minHeight: 0,
        minWidth: 0,
        padding: 0,
        color: theme.palette.neutral?.white,
        fontWeight: '400',
        textAlign: 'center',
        pointerEvents: 'none',
      },
    },
    '& .description-container-title': {
      background: 'radial-gradient(circle, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 50%, rgba(0, 0, 0, 0.3) 100%)',
      borderRadius: getResponsiveSize(8),
    },
  },
};
